module.exports = __webpack_public_path__ + "media/images/sp/specials/common/icon_number_03-4739b6ffeeef40ef3e616204a3b59723.svg";